<template>
  <div id="container" class="effect aside-float aside-bright mainnav-out slide">
    <header id="navbar">
      <div id="navbar-container" class="boxed">
        <div class="navbar-header">
          <div class="navbar-brand" tag="a">
            <img src="../../assets/logo.png" class="brand-icon" />
          </div>
        </div>
        <div class="navbar-content">
          <ul class="nav">
            <li class="tgl-menu-btn text-main">
              <h3>iData数据管理平台</h3>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <div class="boxed">
      <div class="cls-content">
        <div class="cls-content-sm panel">
          <div class="logo-w">
            <h3>登录</h3>
          </div>
          <el-tabs class="login-tabs" @tab-click="errorMessage = ''">
            <el-tab-pane label="短信登录">
              <div class="panel-body">
                <div class="panel-alert login" v-show="errorMessage">
                  <div class="alert-wrap in">
                    <div class="alert alert-danger" role="alert">
                      <div class="media">
                        <h4 class="alert-title">{{ errorMessage }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="loginSubmit">
                  <div class="form-group">
                    <input
                      type="tel"
                      class="form-control"
                      placeholder="输入手机号"
                      v-model="phoneNumber"
                      maxlength="11"
                      autocomplete="on"
                      @input="errorMessage = ''"
                    />
                  </div>
                  <div class="form-group captcha">
                    <input
                      type="text"
                      maxlength="6"
                      class="form-control"
                      placeholder="输入验证码"
                      autocomplete="off"
                      v-model="smsCaptcha"
                      @input="errorMessage = ''"
                    />
                    <div
                      class="input-group-addon"
                      @click="sendCaptcha"
                      v-if="!computedTime"
                    >
                      获取验证码
                    </div>
                    <div class="input-group-addon" v-show="computedTime">
                      已发送({{ computedTime }}s)
                    </div>
                  </div>
                  <button
                    class="btn btn-primary btn-lg btn-block"
                    type="submit"
                  >
                    登录
                  </button>
                </form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="密码登录">
              <div class="panel-body">
                <div class="panel-alert login" v-show="errorMessage">
                  <div class="alert-wrap in">
                    <div class="alert alert-danger" role="alert">
                      <div class="media">
                        <h4 class="alert-title">{{ errorMessage }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="handlePasswordLogin">
                  <div class="form-group">
                    <input
                      type="tel"
                      class="form-control"
                      placeholder="输入手机号"
                      v-model="phoneNumber"
                      maxlength="11"
                      autocomplete="on"
                      @input="errorMessage = ''"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control"
                      placeholder="输入密码"
                      v-model="password"
                      maxlength="20"
                      autocomplete="on"
                      @input="errorMessage = ''"
                    />
                  </div>
                  <div class="form-group captcha paswd">
                    <input
                      type="text"
                      maxlength="6"
                      class="form-control"
                      placeholder="输入验证码"
                      autocomplete="off"
                      v-model="captcha"
                      @input="errorMessage = ''"
                    />
                    <img
                      :src="captchaImageUrl"
                      @click="reloadCaptchaImageUrl"
                    />
                  </div>
                  <button
                    class="btn btn-primary btn-lg btn-block"
                    type="submit"
                  >
                    登录
                  </button>
                </form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <footer id="footer">
        <p class="text-center">
          &#0169; {{ new Date().getFullYear() }} 海锐能源
        </p>
      </footer>
      <button class="scroll-top btn">
        <i class="pci-chevron chevron-up"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import {
  mobileCode,
  loginPost,
  loginVerification,
  passwordLogin,
  getCaptcha,
} from '@/service/getData'
import { urlPerfix } from '@/config/env.js'

export default {
  data() {
    return {
      password: '',
      phoneNumber: '',
      errorMessage: null,
      name: null,
      smsCaptcha: '',
      captcha: '',
      computedTime: 0,
      captchaId: null,
      captchaImageUrl: null,
    }
  },
  created() {
    this.loadCaptcha()
  },
  methods: {
    ...mapMutations(['RECORD_USERINFO']),
    rightPhoneNumber: function () {
      return /^1\d{10}$/gi.test(this.phoneNumber)
    },
    async loadCaptcha() {
      let res = await getCaptcha()
      this.captchaId = res.data.captchaId
      this.captchaImageUrl = urlPerfix + res.data.imageUrl
    },
    reloadCaptchaImageUrl() {
      this.captchaImageUrl += '?reload=true'
    },
    async sendCaptcha() {
      if (this.rightPhoneNumber()) {
        let res = await mobileCode(this.phoneNumber)
        if (res.status == 0) {
          this.computedTime = 60
          this.timer = setInterval(() => {
            this.computedTime--
            if (this.computedTime == 0) {
              clearInterval(this.timer)
            }
          }, 1000)
        } else {
          this.errorMessage = res.msg
        }
      } else {
        this.errorMessage = '手机号错误'
      }
    },

    async loginSubmit() {
      if (!this.rightPhoneNumber()) {
        this.errorMessage = '手机号错误'
        return
      }

      if (!this.smsCaptcha) {
        this.errorMessage = '验证码错误'
        return
      }

      let res = await loginVerification(
        this.phoneNumber,
        parseInt(this.smsCaptcha),
        this.password
      )

      if (res.status != 0) {
        return
      }

      let data = res.data
      this.RECORD_USERINFO(data)
      this.$router.push('/dashboard')
    },

    async handlePasswordLogin() {
      if (!this.rightPhoneNumber()) {
        this.errorMessage = '手机号错误'
        return
      }
      if (!this.password) {
        this.errorMessage = '密码错误'
        return
      }

      if (!this.captcha) {
        this.errorMessage = '验证码错误'
        return
      }

      const params = {
        token_validate: false,
        mobile: this.phoneNumber,
        captcha_id: this.captchaId,
        img_captcha: this.captcha,
        password: this.password,
      }

      let res = await passwordLogin(params)
      if (res.status != 0) {
        this.loadCaptcha()
        return
      }

      let data = res.data
      this.RECORD_USERINFO(data)
      this.$router.push('/dashboard')
    },
  },
}
</script>
<style>
.login-tabs .el-tabs__nav-scroll {
  padding: 0 60px !important;
}
</style>
<style scoped>
.paswd {
  display: flex;
}

.paswd input {
  width: 150px !important;
}
.paswd img {
  width: 38%;
  height: intrinsic;
  margin-left: 8%;
  margin-right: 4%;
}
.cls-content {
  padding-top: 200px;
}
.panel-body {
  /* padding: 25px 30px 40px; */
  padding: 40px 60px;
  padding-top: 20px;
}
.cls-content-sm {
  width: 396px;
  background: #fff;
  text-align: center;
  padding: 0 !important;
  padding-top: 20px !important;
}
.form-group.captcha {
  display: flex;
  justify-content: space-between;
}
.form-group.captcha input {
  width: 212px;
}
.input-group-addon {
  margin-left: 10px;
  width: 128px;
  font-size: 14px;
  color: #1976d2;
  /* border: 1px solid #294f74; */
  /* border-radius: 3px !important; */
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  height: 40px;
  box-sizing: border-box;
  width: 100%;
}
.btn-block {
  margin-top: 30px;
  width: 100%;
  display: block;
}
.alert-danger {
  background: #fff;
  border-left: 0;
  padding-top: 0;
  text-align: left;
  box-shadow: none;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
}
.alert-title {
  padding-right: 0;
  color: #f0685e;
  margin-top: 0;
}
.mar-ver.login {
  text-align: left;
  color: #333;
  margin-top: 0 !important;
}
.mar-ver.login h2 {
  margin-bottom: 0px;
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin-top: 0 !important;
}
.logo-w {
  margin-bottom: 10px;
  text-align: left;
  padding-left: 60px;
}
</style>